import { useEffect, useMemo, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import "./MemoryGamePreferenceDropdown.css";
import "./NotesCategoryFilterDropdown.css";
import "./NotesSpreadFontDropdown.css";

export const NOTES_SPREAD_TYPEFACES = [
  { value: "georgia", label: "Georgia" },
  { value: "comic", label: "Comic Sans" },
];

export function sanitizeNotesSpreadTypeface(value) {
  return value === "comic" ? "comic" : "georgia";
}

export default function NotesSpreadFontDropdown({
  value = "georgia",
  onChange = () => {},
}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const selected = sanitizeNotesSpreadTypeface(value);

  const selectedOption = useMemo(
    () =>
      NOTES_SPREAD_TYPEFACES.find((option) => option.value === selected) ||
      NOTES_SPREAD_TYPEFACES[0],
    [selected]
  );

  useEffect(() => {
    if (!dropdownOpen) return undefined;

    const handlePointerDown = (event) => {
      if (dropdownRef.current?.contains(event.target)) return;
      setDropdownOpen(false);
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") setDropdownOpen(false);
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [dropdownOpen]);

  const handleSelect = (next) => {
    onChange(sanitizeNotesSpreadTypeface(next));
    setDropdownOpen(false);
  };

  return (
    <div
      className={`memory-game-pref-dropdown notes-category-filter-dropdown notes-spread-font-dropdown${
        dropdownOpen ? " memory-game-pref-dropdown--open" : ""
      }`}
      ref={dropdownRef}
    >
      <button
        type="button"
        className="memory-game-pref-dropdown__trigger"
        aria-haspopup="listbox"
        aria-expanded={dropdownOpen}
        aria-label="Police de caractère"
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => setDropdownOpen((open) => !open)}
      >
        <span className="memory-game-pref-dropdown__label">{selectedOption.label}</span>
        <ChevronDown
          size={16}
          strokeWidth={2}
          className="memory-game-pref-dropdown__chevron"
          aria-hidden="true"
        />
      </button>

      {dropdownOpen && (
        <ul className="memory-game-pref-dropdown__menu" role="listbox">
          {NOTES_SPREAD_TYPEFACES.map((option) => (
            <li key={option.value} role="presentation">
              <button
                type="button"
                role="option"
                aria-selected={option.value === selected}
                className={`memory-game-pref-dropdown__option${
                  option.value === selected
                    ? " memory-game-pref-dropdown__option--selected"
                    : ""
                }`}
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => handleSelect(option.value)}
              >
                {option.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
